





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { HelperMethods } from '@/core/HelperMethods';
import { ChangelogCategoryViewObject, WoWClass, WoWRace } from '@/types/apiServerContract';

@Component
export default class ChangelogEntryCategory extends Vue {
	@Prop({ required: false, type: String, default: 'div' }) tag!: string;
	@Prop({ required: true, type: Object }) category!: ChangelogCategoryViewObject;
	@Prop({ type: Number, default: 1.35 }) fontSize!: number;
	@Prop({ type: Number, default: 0 }) nestedIndex!: number;

	get style() {
	    return `font-size: ${Math.max(1, this.fontSize * (1 - 0.1 * this.nestedIndex))}rem;`;
	}

	get gameClass() {
	    return this.category.gameClass;
	}

	get gameRace() {
	    return this.category.gameRace;
	}

	getClassColor(classId: WoWClass) {
	    return HelperMethods.GetClassColor(classId);
	}

	getClassName(classId: WoWClass) {
	    return HelperMethods.GetClassName(classId);
	}

	getRaceColor(raceId: WoWRace) {
	    return HelperMethods.GetRaceColor(raceId);
	}

	getRaceName(raceId: WoWRace) {
	    return HelperMethods.GetRaceName(raceId);
	}
}
